import _ from 'lodash';
import actions from '../actions/agent/form';
import api_actions from '../actions/api';
import redirect from '../../utils/redirect';
import {populateFields} from '../../utils/schema.utils';
import {getInitialValues} from '../../utils/full.schema.utils';
import {cleanPostcodeErrors, mapPostcodes} from "../../utils/redux.utils";

const updateUuidObject = (_state, action, new_data, _uuid = null) => {
    const state = {..._state};
    const uuid = _.get(action, 'payload.data.uuid', '') || _uuid;

    if (!uuid) return state;
    if (!state[uuid]) state[uuid] = {};

    state[uuid] = {...state[uuid], ...new_data};

    return state;
};

const actionHandlers = {
    [actions.form_get_data]: (state, action) => {
        const {uuid} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateUuidObject(state, action, {isLoading: true, errors: {}}, uuid);
            case api_actions.api_end:
                return updateUuidObject(state, action, {isLoading: false}, uuid);
            default:
                return state;
        }
    },
    [actions.form_succeeded]: (state, action, name) => {
        const {uuid, sources, state: lead_state, conversion_uuid, details} = action.payload;
        const mapSources = sources ? sources : state[uuid] && state[uuid].sources ? state[uuid].sources : [];
        const _uuid = uuid || action.uuid;
        const data = _.isEmpty(details) ? (state[uuid] && state[uuid].data ? state[uuid].data : {}) : details;

        return {
            ...updateUuidObject(state, action, {data: {...getInitialValues(name), ...populateFields(data)}, lead_state, conversion_uuid, sources: mapSources}, _uuid),
            ...(_uuid ? redirect.add(`/${name}/${_uuid}`) : {}),
        };
    },
    [actions.form_failed]: (state, action) => {
        const {uuid} = action;
        const errors = _.get(action, 'payload.data.error');
        return updateUuidObject(state, action, {errors: !_.isEmpty(errors) ? errors : 'Please try later'}, uuid);
    },
    [actions.vrm_search]: (state, action) => {
        const {uuid} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateUuidObject(state, action, {vrmIsLoading: true, vrmErrors: {}}, uuid);
            case api_actions.api_end:
                return updateUuidObject(state, action, {vrmIsLoading: false}, uuid);
            default:
                return state;
        }
    },
    [actions.vrm_failed]: (state, action) => {
        const {uuid} = action;
        const errors = _.get(action, 'payload.data.error');
        return updateUuidObject(state, action, {vrmErrors: !_.isEmpty(errors) ? errors : 'Our vehicle lookup service is down, please enter manually'}, uuid);
    },
    [actions.vrm_succeeded]: (state, action) => {
        const {uuid} = action;
        return updateUuidObject(state, action, {vrmData: action.payload}, uuid);
    },
    [actions.postcode_search]: (state, action) => {
        const {uuid} = action;
        switch (action.payload) {
            case api_actions.api_start:
                return updateUuidObject(state, action, {postcodeIsLoading: true, postcodeErrors: {}}, uuid);
            case api_actions.api_end:
                return updateUuidObject(state, action, {postcodeIsLoading: false}, uuid);
            default:
                return state;
        }
    },
    [actions.postcode_failed]: (state, action) => {
        const {uuid} = action;
        const errors = _.get(action, 'payload.data.error');
        const error = !_.isEmpty(errors) ? errors : 'Our postcode lookup service is down, please enter manually';
        const formErrors = cleanPostcodeErrors(_.get(state, `${uuid}.errors`, {}))

        return updateUuidObject(state, action, {
            postcodeErrors: error,
            mappedPostcodes: [],
            errors: {...formErrors, postcode: error}
        }, uuid);
    },
    [actions.postcode_succeeded]: (state, action) => {
        const {uuid} = action;
        const mappedPostcodes =mapPostcodes(action.payload);
        const errors = cleanPostcodeErrors(_.get(state, `${uuid}.errors`, {}))

        return updateUuidObject(state, action, {
            postcodeData: action.payload,
            mappedPostcodes,
            errors
        }, uuid);
    },
    [actions.add]: (state, action) => {
        const {fields, uuid, formValues} = action.payload;
        if (!uuid || !fields) return state;
        const new_fields = fields.reduce((acc, curr) => acc = {...acc, [curr]: ''}, {});
        return updateUuidObject(state, action, {data: {...formValues, ...new_fields}}, uuid);
    },
    [actions.remove]: (state, action) => {
        const {fields, uuid, formValues} = action.payload,
            {1: field_name, 2: field_index} = fields[0].match(/^(.*)_(\d{1,2})_/),
            regex = new RegExp('^(.*)field_name_(\\d{1,2})_'.replace('field_name', field_name));

        if (!uuid || !fields) return state;
        const dataAux = _.omit(formValues, [...fields]),
            new_data = {};

        _.forEach(dataAux, (v, k) => {
            if (k.match(regex)) {
                const {2: index} = k.match(regex);
                const newKey = k.replace(/_\d{1,2}_/, index > field_index ? `_${index - 1}_` : `_${index}_`);
                new_data[newKey] = v;
            } else {
                new_data[k] = v;
            }
        });

        return updateUuidObject(state, action, {data: {...new_data}}, uuid);
    },
};

const formReducer = (formName = '') => {
    return function form(state = getDefaults(), action) {

        let {name} = action;

        if (name !== formName) return state;

        if (actionHandlers[action.type]) return actionHandlers[action.type](state, action, name);

        return state;
    };
};

export function getDefaults() {
    return {};
}

export default formReducer;

const handleFormSucceeded = (state, action) => {
    if (action.payload.conversion_state !== 'failed') return state;

    const {payload: {conversion_uuid, conversion_unmatched}} = action;
    return {
        ...state,
        conversion: {
            ...state.conversion,
            [conversion_uuid]: {
                ...state.conversion[conversion_uuid],
                unmatched: conversion_unmatched,
            },
        },
    };
};

export {handleFormSucceeded};
